<div class="app-header">
  <div class="banner">
    <div [ngStyle]="{'background-image':'url(' + banner + ')'}" class="banner__bg">
      <div class="banner__content">
        <h2 class="banner__content__pretitle">{{'Events' | transloco}}</h2>
        <h1 class="banner__content__title">{{'Results' | transloco}}</h1>
      </div>
    </div>
  </div>
</div>

<div class="app-content">
  <router-outlet></router-outlet>
</div>
